'use client'

import type { CSSProperties, MouseEvent } from 'react'
import { useTranslations } from 'next-intl'

/**
 * "¿Por qué?" — la entrada al explicador del envío (spec 2026-09-03 §3).
 * Texto corto visible, aria-label completo. Es un botón de verdad y frena la
 * propagación: vive dentro de filas y contenedores que ya son clickeables.
 * NUNCA se anida dentro de otro <button> (HTML inválido): los callers lo
 * colocan como hermano de sus botones.
 */
export function WhyFeeLink({
  onClick,
  className,
  style,
}: {
  onClick: () => void
  className?: string
  style?: CSSProperties
}) {
  const t = useTranslations('public.onlineOrder.checkout.whyFee')
  function handle(e: MouseEvent<HTMLButtonElement>) {
    e.stopPropagation()
    onClick()
  }
  return (
    <button
      type="button"
      onClick={handle}
      aria-label={t('linkAria')}
      className={`inline text-xs font-semibold underline underline-offset-2 hover:opacity-80 ${className ?? ''}`}
      style={style}
    >
      {t('link')}
    </button>
  )
}
